import ExcelJS from "exceljs";
import { VIETNAM_BANKS } from "../../../data/vietnamBanks";

/** Tên sheet dữ liệu — backend import tìm theo tên này */
export const TEACHER_IMPORT_DATA_SHEET = "Danh sách";

const thinBorder = {
  top: { style: "thin", color: { argb: "FFD1D5DB" } },
  left: { style: "thin", color: { argb: "FFD1D5DB" } },
  bottom: { style: "thin", color: { argb: "FFD1D5DB" } },
  right: { style: "thin", color: { argb: "FFD1D5DB" } },
};

const COLS = [
  {
    header: "Họ tên",
    width: 24,
    required: true,
    format: "Văn bản",
    example: "Nguyễn Văn A",
    note: "Họ tên đầy đủ, không bỏ trống.",
  },
  {
    header: "Email",
    width: 32,
    required: true,
    format: "Email hợp lệ",
    example: "giao.vien@truong.edu.vn",
    note: "Email cá nhân dùng đăng nhập APP. Mỗi email chỉ dùng một lần trong hệ thống.",
  },
  {
    header: "Số điện thoại",
    width: 16,
    required: false,
    format: "Số, 9–11 ký tự",
    example: "0901234567",
    note: "Tuỳ chọn. Có thể để trống.",
  },
  {
    header: "Ngày sinh",
    width: 14,
    required: false,
    format: "Ngày (dd/mm/yyyy) hoặc yyyy-mm-dd",
    example: "15/01/1990",
    note: "Chọn định dạng Ngày trong Excel hoặc gõ yyyy-mm-dd.",
  },
  {
    header: "Giới tính",
    width: 12,
    required: false,
    format: "nam / nữ (hoặc male / female)",
    example: "nam",
    note: "Chọn từ danh sách gợi ý trên sheet Danh sách.",
  },
  {
    header: "Mã ngân hàng",
    width: 14,
    required: false,
    format: "Mã ngắn (VCB, BIDV…)",
    example: "VCB",
    note: "Tra mã tại sheet «Mã ngân hàng VN».",
  },
  {
    header: "Số tài khoản",
    width: 18,
    required: false,
    format: "Văn bản / số",
    example: "0123456789",
    note: "Số tài khoản nhận lương/thanh toán (tuỳ chọn).",
  },
  {
    header: "Tên tài khoản",
    width: 26,
    required: false,
    format: "IN HOA, không dấu",
    example: "NGUYEN VAN A",
    note: "Tên chủ tài khoản ngân hàng (tuỳ chọn).",
  },
  {
    header: "Ghi chú",
    width: 28,
    required: false,
    format: "Văn bản tự do",
    example: "GV Tiếng Anh khối THCS",
    note: "Ghi chú nội bộ, không ảnh hưởng đăng nhập.",
  },
  {
    header: "Hạn mức tháng",
    width: 14,
    required: false,
    format: "Số nguyên 0–1000",
    example: "5",
    note: "Lượt tải/xem tài liệu mỗi tháng. Mặc định: 5 nếu để trống.",
  },
  {
    header: "Lượt bonus",
    width: 12,
    required: false,
    format: "Số nguyên ≥ 0",
    example: "0",
    note: "Lượt tải bổ sung. Mặc định: 0 nếu để trống.",
  },
  {
    header: "Miễn trừ hạn mức",
    width: 16,
    required: false,
    format: "có / không (hoặc true / false)",
    example: "không",
    note: "có = không giới hạn tài liệu theo tháng.",
  },
  {
    header: "Số thiết bị tối đa",
    width: 18,
    required: false,
    format: "Bỏ qua (legacy)",
    example: "—",
    note: "Cột legacy. Hệ thống luôn áp dụng: 1 máy tính + 1 điện thoại.",
  },
  {
    header: "Mã khóa học",
    width: 30,
    required: false,
    format: "Mã cách nhau bằng dấu phẩy",
    example: "ENG-TH1, MATH-TH2",
    note: "Gán khóa học ngay khi import. Tra mã tại sheet «Mã khóa học». Để trống = khóa mặc định trên màn hình import.",
  },
];

const DATA_ENTRY_ROWS = 200;
const GENDER_LIST = '"nam,nữ,male,female"';
const EXEMPT_LIST = '"có,không,true,false,1,0"';

function styleTitleCell(cell, { size = 16, color = "FF7F1D1D", bg = "FFFEE2E2" } = {}) {
  cell.font = { bold: true, size, color: { argb: color } };
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  cell.border = thinBorder;
}

function styleSectionTitle(cell) {
  cell.font = { bold: true, size: 12, color: { argb: "FFB91C1C" } };
  cell.alignment = { vertical: "middle", wrapText: true };
}

function styleBodyCell(cell, { bold = false, italic = false, bg = null } = {}) {
  cell.font = { size: 11, bold, italic, color: { argb: "FF374151" } };
  cell.alignment = { vertical: "top", wrapText: true };
  if (bg) {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  }
  cell.border = thinBorder;
}

function buildGuideSheet(wb) {
  const ws = wb.addWorksheet("Hướng dẫn", {
    views: [{ state: "frozen", ySplit: 1 }],
    properties: { defaultRowHeight: 18 },
  });
  const ncol = 6;
  ws.columns = [
    { width: 4 },
    { width: 22 },
    { width: 12 },
    { width: 28 },
    { width: 16 },
    { width: 52 },
  ];

  let r = 1;
  ws.mergeCells(r, 1, r, ncol);
  const t = ws.getCell(r, 1);
  t.value = "HƯỚNG DẪN SỬ DỤNG BIỂU MẪU IMPORT GIÁO VIÊN ĐỐI TÁC";
  styleTitleCell(t, { size: 15 });
  ws.getRow(r).height = 36;
  r += 1;

  ws.mergeCells(r, 1, r, ncol);
  const sub = ws.getCell(r, 1);
  sub.value =
    "IMA Vietnam ERP — Tài khoản giáo viên đối tác (trường học liên kết). Phiên bản biểu mẫu: 2026.";
  sub.font = { italic: true, size: 10, color: { argb: "FF6B7280" } };
  sub.alignment = { horizontal: "center", wrapText: true };
  r += 2;

  const addSection = (title, lines) => {
    ws.mergeCells(r, 1, r, ncol);
    const c = ws.getCell(r, 1);
    c.value = title;
    styleSectionTitle(c);
    ws.getRow(r).height = 22;
    r += 1;
    for (const line of lines) {
      ws.mergeCells(r, 1, r, ncol);
      const lc = ws.getCell(r, 1);
      lc.value = line;
      styleBodyCell(lc);
      ws.getRow(r).height = line.length > 80 ? 36 : 20;
      r += 1;
    }
    r += 1;
  };

  addSection("I. QUY TRÌNH IMPORT TRÊN HỆ THỐNG", [
    "Bước 1 — Mở chức năng «Tài khoản giáo viên đối tác» → «Import giáo viên».",
    "Bước 2 — Chọn Chi nhánh và Trường (khách hàng). Toàn bộ giáo viên trong file sẽ gắn với một trường.",
    "Bước 3 — (Tuỳ chọn) Chọn «Khóa học mặc định» nếu có quyền gán khóa học.",
    "Bước 4 — Nhập dữ liệu vào sheet «Danh sách» (mỗi dòng = một giáo viên), lưu file .xlsx.",
    "Bước 5 — Tải file lên hệ thống. Mỗi tài khoản được tạo kèm mật khẩu ngẫu nhiên, gán vai trò giáo viên đối tác và gửi email hướng dẫn đăng nhập.",
  ]);

  addSection("II. CÁCH NHẬP LIỆU TRÊN SHEET «DANH SÁCH»", [
    "• Dòng 1 là tiêu đề cột — KHÔNG xoá, KHÔNG đổi tên cột.",
    "• Nhập dữ liệu từ dòng 2 trở xuống. Mỗi dòng trống (không có Họ tên và Email) sẽ bỏ qua.",
    "• Cột nền vàng nhạt là vùng nhập liệu. Cột có dấu * là bắt buộc.",
    "• Có thể copy/dán từ file khác — giữ đúng thứ tự cột như dòng tiêu đề.",
    "• Không gộp ô, không chèn dòng phía trên dòng tiêu đề.",
  ]);

  ws.mergeCells(r, 1, r, ncol);
  ws.getCell(r, 1).value = "III. BẢNG MÔ TẢ CỘT DỮ LIỆU";
  styleSectionTitle(ws.getCell(r, 1));
  ws.getRow(r).height = 22;
  r += 1;

  const hdr = ws.getRow(r);
  ["STT", "Tên cột", "Bắt buộc", "Định dạng / Giá trị", "Ví dụ", "Ghi chú"].forEach((label, idx) => {
    const c = hdr.getCell(idx + 1);
    c.value = label;
    c.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFB91C1C" } };
    c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    c.border = thinBorder;
  });
  hdr.height = 26;
  r += 1;

  COLS.forEach((col, idx) => {
    const row = ws.getRow(r);
    const vals = [
      idx + 1,
      col.required ? `${col.header} *` : col.header,
      col.required ? "Có" : "Không",
      col.format,
      col.example,
      col.note,
    ];
    vals.forEach((val, ci) => {
      const c = row.getCell(ci + 1);
      c.value = val;
      styleBodyCell(c, { bg: idx % 2 === 0 ? "FFF9FAFB" : "FFFFFFFF" });
      c.alignment = { vertical: "top", wrapText: true, horizontal: ci === 0 ? "center" : "left" };
    });
    row.height = 42;
    r += 1;
  });
  r += 1;

  addSection("IV. VÍ DỤ HAI DÒNG DỮ LIỆU HỢP LỆ", [
    "Nguyễn Văn A | a1@school.edu.vn | 0901234567 | 15/01/1990 | nam | VCB | 0123456789 | NGUYEN VAN A | — | 5 | 0 | không | — | ENG-TH1, MATH-TH2",
    "Trần Thị B | b2@school.edu.vn | 0918765432 | (trống) | nữ | BIDV | 9876543210 | TRAN THI B | Ghi chú mẫu | 10 | 5 | có | — | (trống → dùng khóa mặc định trên màn hình)",
  ]);

  addSection("V. LƯU Ý QUAN TRỌNG", [
    "• Email phải là email thật — hệ thống gửi mật khẩu đăng nhập qua email này.",
    "• Một giáo viên có thể gán NHIỀU khóa học: ghi nhiều mã, cách nhau bằng dấu phẩy ở cột «Mã khóa học».",
    "• Mã khóa học phải đúng với danh mục khóa của chi nhánh — tra cứu tại sheet «Mã khóa học» (tải mẫu sau khi chọn chi nhánh).",
    "• Thiết bị đăng nhập APP: mỗi tài khoản tối đa 1 máy tính + 1 điện thoại (cột «Số thiết bị tối đa» không còn tác dụng).",
    "• Sheet «Mã ngân hàng VN» và «Mã khóa học» chỉ để tra cứu — không nhập dữ liệu giáo viên vào các sheet này.",
    "• Khi import, hệ thống đọc sheet «Danh sách» (không đọc sheet Hướng dẫn).",
  ]);

  return ws;
}

function buildDataSheet(wb) {
  const ws = wb.addWorksheet(TEACHER_IMPORT_DATA_SHEET, {
    views: [{ state: "frozen", ySplit: 1 }],
  });

  const headers = COLS.map((c) => (c.required ? `${c.header} *` : c.header));
  const headerRow = ws.getRow(1);
  headers.forEach((h, idx) => {
    const col = idx + 1;
    const cell = headerRow.getCell(col);
    cell.value = h;
    cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFB91C1C" } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = thinBorder;
    ws.getColumn(col).width = COLS[idx].width;
  });
  headerRow.height = 32;
  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: COLS.length },
  };

  for (let i = 0; i < DATA_ENTRY_ROWS; i += 1) {
    const rowNum = i + 2;
    const row = ws.getRow(rowNum);

    COLS.forEach((colDef, idx) => {
      const cell = row.getCell(idx + 1);
      cell.value = "";
      cell.border = thinBorder;
      cell.alignment = { vertical: "center", wrapText: true };
      const isLegacy = colDef.header === "Số thiết bị tối đa";
      const bg = isLegacy ? "FFF3F4F6" : colDef.required ? "FFFEF9C3" : "FFFFFBEB";
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    });
    row.height = 22;
  }

  const genderCol = "E";
  const exemptCol = "L";
  for (let rowNum = 2; rowNum <= DATA_ENTRY_ROWS + 1; rowNum += 1) {
    ws.getCell(`${genderCol}${rowNum}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [GENDER_LIST],
      showErrorMessage: true,
      errorTitle: "Giới tính",
      error: "Chọn: nam, nữ, male hoặc female.",
    };
    ws.getCell(`${exemptCol}${rowNum}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [EXEMPT_LIST],
      showErrorMessage: true,
      errorTitle: "Miễn trừ hạn mức",
      error: "Chọn: có, không, true, false, 1 hoặc 0.",
    };
  }


  ws.getCell("A1").note =
    "Không xoá / đổi tên dòng tiêu đề. Nhập từ dòng 2. Xem sheet «Hướng dẫn» để biết chi tiết.";
  ws.getCell("B1").note = "Email dùng đăng nhập APP — bắt buộc, không trùng.";
  ws.getCell("N1").note =
    "Nhiều mã cách nhau bằng dấu phẩy. Tra sheet «Mã khóa học». Để trống = khóa mặc định trên màn hình import.";

  return ws;
}

function buildCourseSheet(wb, { branchName = "", courses = [] } = {}) {
  const ws = wb.addWorksheet("Mã khóa học", {
    views: [{ state: "frozen", ySplit: 3 }],
  });
  const colCount = 5;
  ws.columns = [
    { width: 18 },
    { width: 36 },
    { width: 22 },
    { width: 16 },
    { width: 42 },
  ];

  ws.mergeCells(1, 1, 1, colCount);
  const title = ws.getCell(1, 1);
  title.value = branchName
    ? `DANH MỤC KHÓA HỌC — Chi nhánh: ${branchName}`
    : "DANH MỤC KHÓA HỌC (chọn chi nhánh trên màn hình import rồi tải lại file mẫu)";
  styleTitleCell(title, { size: 13 });
  ws.getRow(1).height = 32;

  ws.mergeCells(2, 1, 2, colCount);
  const hint = ws.getCell(2, 1);
  hint.value =
    "Copy cột «Mã khóa học» vào sheet «Danh sách» (cột Mã khóa học). Nhiều khóa: cách nhau bằng dấu phẩy, vd: ENG-TH1, MATH-TH2. Sheet này chỉ tra cứu — không import.";
  hint.font = { italic: true, size: 10, color: { argb: "FF92400E" } };
  hint.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFEF3C7" } };
  hint.alignment = { vertical: "middle", wrapText: true };
  hint.border = thinBorder;
  ws.getRow(2).height = 36;

  const hdr = ws.getRow(3);
  ["Mã khóa học", "Tên khóa học", "Môn học", "Cấp học", "Ghi chú nhập liệu"].forEach(
    (label, idx) => {
      const c = hdr.getCell(idx + 1);
      c.value = label;
      c.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
      c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFB91C1C" } };
      c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      c.border = thinBorder;
    }
  );
  hdr.height = 28;

  const sorted = [...courses].sort((a, b) => {
    const sa = a.subject_sort_order ?? 0;
    const sb = b.subject_sort_order ?? 0;
    if (sa !== sb) return sa - sb;
    return String(a.name || "").localeCompare(String(b.name || ""), "vi");
  });

  if (sorted.length === 0) {
    ws.mergeCells(4, 1, 4, colCount);
    const empty = ws.getCell(4, 1);
    empty.value =
      "Chưa có khóa học cho chi nhánh đã chọn (hoặc tài khoản chưa có quyền xem danh mục). Vẫn có thể import giáo viên — để trống cột Mã khóa học hoặc chọn khóa mặc định trên màn hình.";
    styleBodyCell(empty, { italic: true, bg: "FFF9FAFB" });
    ws.getRow(4).height = 48;
    return ws;
  }

  sorted.forEach((course, i) => {
    const row = ws.getRow(i + 4);
    const code = course.code || "";
    const values = [
      code,
      course.name || "",
      course.subject_name || "",
      course.level || "",
      code
        ? `Nhập "${code}" vào cột Mã khóa học (sheet Danh sách)`
        : "Khóa chưa có mã — liên hệ admin",
    ];
    values.forEach((val, ci) => {
      const c = row.getCell(ci + 1);
      c.value = val;
      c.border = thinBorder;
      c.alignment = { vertical: "center", wrapText: true };
      if (ci === 0) {
        c.font = { bold: true, color: { argb: "FFB91C1C" } };
      }
      c.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: i % 2 === 0 ? "FFFFFFFF" : "FFF9FAFB" },
      };
    });
    row.height = 22;
  });

  ws.autoFilter = {
    from: { row: 3, column: 1 },
    to: { row: 3 + sorted.length, column: colCount },
  };

  return ws;
}

function buildBankSheet(wb) {
  const ws = wb.addWorksheet("Mã ngân hàng VN");
  ws.columns = [{ width: 10 }, { width: 54 }];
  const hdr = ws.getRow(1);
  ["Mã", "Tên ngân hàng (tham khảo)"].forEach((label, idx) => {
    const c = hdr.getCell(idx + 1);
    c.value = label;
    c.font = { bold: true, color: { argb: "FFFFFFFF" } };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF374151" } };
    c.alignment = { horizontal: "center", vertical: "middle" };
    c.border = thinBorder;
  });
  VIETNAM_BANKS.forEach((b, i) => {
    const row = ws.getRow(i + 2);
    row.getCell(1).value = b.value;
    row.getCell(2).value = b.label;
    row.getCell(1).border = thinBorder;
    row.getCell(2).border = thinBorder;
  });
  ws.views = [{ state: "frozen", ySplit: 1 }];
  return ws;
}

function triggerDownload(buffer, filename) {
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Tải biểu mẫu import giáo viên đối tác (.xlsx) có định dạng và hướng dẫn chi tiết.
 * Sheet: Hướng dẫn → Danh sách → Mã khóa học → Mã ngân hàng VN.
 * @param {{ branchName?: string, courses?: object[] }} options
 */
export async function downloadTeacherImportTemplateXlsx(options = {}) {
  const { branchName = "", courses = [] } = options;
  const wb = new ExcelJS.Workbook();
  wb.creator = "IMA Vietnam ERP";
  wb.created = new Date();
  wb.properties.date1904 = false;

  buildGuideSheet(wb);
  buildDataSheet(wb);
  buildCourseSheet(wb, { branchName, courses });
  buildBankSheet(wb);

  const buffer = await wb.xlsx.writeBuffer();
  triggerDownload(buffer, "mau_giao_vien_doi_tac.xlsx");
}
